import { createRootRouteWithContext } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { AppShell } from "@/components/AppShell";

// Root route: aplica el AppShell. Recibe queryClient en context para que
// los `beforeLoad` de los hijos puedan invalidar/ensurear queries (p.ej.
// requireRoleGuard usa context.queryClient para resolver /me).
export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: AppShell,
});
